var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isModalVisible,
          expression: "isModalVisible"
        }
      ]
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-mask",
          attrs: { id: "groupModal6" },
          on: { click: _vm.closeModal }
        },
        [
          _vm.loading == false
            ? _c(
                "div",
                {
                  staticClass: "modal-container",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c("div", { staticClass: "col-12 p-0" }, [
                      _c(
                        "div",
                        { staticClass: "col-6 float-left p-0 text-left" },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-primary btn-md start-button",
                              attrs: { type: "submit" },
                              on: {
                                click: function($event) {
                                  return _vm.closeModal()
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-6 float-left p-0 text-align-right"
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-primary btn-md start-button-blue",
                              attrs: { type: "submit" },
                              on: {
                                click: function($event) {
                                  return _vm.openSkillPass()
                                }
                              }
                            },
                            [_vm._v("Continue")]
                          )
                        ]
                      )
                    ])
                  ])
                ]
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("div", { staticClass: "col-11 p-0 float-left text-center" }, [
        _c("img", {
          staticClass: "w-60 mt1",
          attrs: {
            src: require("@/assets/MM-logo.png"),
            alt: "MentorMentee",
            width: "100px"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c("div", { staticStyle: { "margin-bottom": "10px" } }),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 p-0" }, [
        _c(
          "div",
          {
            staticClass: "col-12 item-text bold p-0",
            staticStyle: { "margin-bottom": "10px" }
          },
          [
            _vm._v(
              "\n            Skill pass allows you to force pass a mentees earned competencies that were not recorded in the rep submission/review process.\n          "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12 item-text text-align-center",
            staticStyle: { "margin-bottom": "10px" }
          },
          [
            _vm._v(
              "\n            This is most commonly used when...\n          "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12 item-text",
            staticStyle: { "padding-left": "30px", "margin-bottom": "17px" }
          },
          [
            _vm._v(
              "\n            1 - A new or current technician is added as a mentee."
            ),
            _c("br"),
            _vm._v(
              "\n            2 - Competency was earned but not recorded in Mentor Mentee\n          "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12 item-text text-align-center bold",
            staticStyle: { "margin-bottom": "10px" }
          },
          [
            _c("i", {
              staticClass: "fa fa-exclamation-triangle angle-class",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" Warning! Once passed competency can not be undone. "),
            _c("i", {
              staticClass: "fa fa-exclamation-triangle angle-class",
              attrs: { "aria-hidden": "true" }
            })
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22e6735e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22e6735e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manager/skillPassWarningModal.vue
// module id = null
// module chunks = 